<section class="sblock-location">
  <div class="container">
    <!-- Heading -->
    <header class="sblock-location__head mb-4">
      <h2 class="sblock-location__title">{{ title }}</h2>
      <span class="sblock-location__eyebrow">{{ eyebrow }}</span>
    </header>

    <!-- Tabs (same pattern as LevelProfile) -->
    <div class="optionsList mb-4">
      <div
        class="option"
        *ngFor="let tab of tabs; let i = index"
        [class.activeOption]="i === activeIndex"
        (click)="setActive(i)"
      >
        {{ tab.label }}
      </div>
      <div class="slide" [ngStyle]="getSlideStyles()"></div>
    </div>

    <!-- Active tab content: every tab shows its own map + contact card -->
    <div class="sblock-location__content">
      <div
        class="sblock-location__map"
        [class.sblock-location__map--level]="!!activeTab.image"
      >
        <!-- Map: the main content on the institutional tab; a blurred backdrop
             behind the level's image on level tabs -->
        <iframe
          class="sblock-location__frame"
          [src]="mapUrl()"
          title="Ubicación en el mapa"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          allowfullscreen
        ></iframe>

        <!-- Level tabs: small rounded image over the blurred map -->
        <img
          *ngIf="activeTab.image"
          class="sblock-location__image"
          [src]="activeTab.image"
          [alt]="activeTab.label"
          onError="this.src='assets/images/placeholder.svg'"
          loading="lazy"
          decoding="async"
        />

        <div class="contact-card" [class.contact-card--flat]="!activeTab.isInstitution">
          <div class="contact-card__header">Contacto</div>
          <div class="contact-card__body">
            <div class="contact-card__row">
              <span class="contact-card__icon">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <span class="contact-card__text">
                <ng-container *ngFor="let line of activeTab.address; let last = last">
                  {{ line }}<br *ngIf="!last" />
                </ng-container>
              </span>
            </div>
            <div class="contact-card__row">
              <span class="contact-card__icon">
                <i class="fas fa-phone-alt"></i>
              </span>
              <span class="contact-card__text">{{ activeTab.phone }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
